import React, { forwardRef, useImperativeHandle } from "react";

const Modal = forwardRef((props, ref) => {
   const { titulo = "", mensaje = "", actionTitle, actionFn } = props;

   let openmodal = document.querySelectorAll(".modal-open");
   for (let i = 0; i < openmodal.length; i++) {
      openmodal[i].addEventListener("click", function (event) {
         event.preventDefault();
         toggleModal();
      });
   }

   document.onkeydown = function (evt) {
      evt = evt || window.event;
      let isEscape = false;
      if ("key" in evt) {
         isEscape = evt.key === "Escape" || evt.key === "Esc";
      } else {
         isEscape = evt.keyCode === 27;
      }
      if (isEscape && document.body.classList.contains("modal-active")) {
         toggleModal();
      }
   };

   function toggleModal() {
      const body = document.querySelector("body");
      const modal = document.querySelector("#confirmar");
      modal.classList.toggle("opacity-0");
      modal.classList.toggle("pointer-events-none");
      body.classList.toggle("modal-active");
   }

   useImperativeHandle(ref, () => ({
      showModal() {
         toggleModal();
      },
      hideModal() {
         toggleModal();
      },
   }));

   return (
      <div
         id="confirmar"
         className="modal opacity-0 pointer-events-none fixed w-full h-full top-0 left-0 flex items-center justify-center"
      >
         <div className="modal-overlay absolute w-full h-full bg-gray-900 opacity-50"></div>
         <div className="modal-container bg-white w-11/12 md:max-w-md mx-auto rounded shadow-lg z-50 overflow-y-auto">
            <div className="modal-close absolute top-0 right-0 cursor-pointer flex flex-col items-center mt-4 mr-4 text-white text-sm z-50">
               <svg
                  className="fill-current text-white"
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
               >
                  <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z"></path>
               </svg>
               <span className="text-sm">(Esc)</span>
            </div>

            <div className="modal-content text-left p-0">
               <div className="flex justify-between items-center pb-3 px-0 bg-orange-900">
                  <p className="text-2xl font-bold text-white px-4 py-2">{titulo}</p>
               </div>
               <p className="text-orange-900 px-3 py-3">{mensaje}</p>
               <div className="flex justify-end pt-2 pb-3 mt-2 px-4">
                  <button
                     className="modal-close px-3 bg-white py-2 rounded text-sm text-orange-900 border border-orange-900 hover:bg-orange-100 focus:outline-none"
                     onClick={toggleModal}
                  >
                     Cerrar
                  </button>
                  <button
                     className="px-3 bg-orange-900 py-2 rounded text-sm text-white hover:bg-orange-800 ml-2 focus:outline-none"
                     onClick={() => actionFn()}
                  >
                     {actionTitle}
                  </button>
               </div>
            </div>
         </div>
      </div>
   );
});

export default Modal;
